import { render } from "./DockRight.vue?vue&type=template&id=7481e512"
import script from "./DockRight.vue?vue&type=script&lang=js"
export * from "./DockRight.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__